import React from 'react';
import clsx from 'clsx';

import Icon from 'carbon-react/lib/components/icon';

import { SyncControlLoading } from '../sync-control-loading/sync-control-loading';
import { SyncControlCta } from '../sync-control-cta/sync-control-cta';
import { SyncControlDatasourceState, SyncControlState } from '../../types';
import { SyncMessage } from '../sync-control-message';
import { SyncControlReconnectCta } from '../sync-control-reconnect-cta/sync-control-reconnect-cta';

import styles from './sync-control.scss';

export interface SyncControlProps {
  datasourceState: SyncControlDatasourceState;
  dataSyncedMessage?: React.ReactNode;
  errorMessage?: React.ReactNode;
  onReconnect: () => void;
  onSyncNow: () => void;
  syncControlState: SyncControlState;
  syncTimestamp: string;
  syncingMessage?: React.ReactNode;
  syncNowMessage?: React.ReactNode;
  showSyncNowLabel?: boolean;
  hideTriggerSync?: boolean;
  needsReconnect?: boolean;
}

export const SyncControl = ({
  datasourceState,
  dataSyncedMessage,
  errorMessage,
  onReconnect,
  onSyncNow,
  syncControlState,
  syncTimestamp,
  syncingMessage,
  syncNowMessage,
  showSyncNowLabel,
  hideTriggerSync,
  needsReconnect
}: SyncControlProps) => {
  const showSpinner =
    datasourceState === SyncControlDatasourceState.SYNCING ||
    datasourceState === SyncControlDatasourceState.RECONNECTING;

  switch (syncControlState) {
    case SyncControlState.LOADING:
    case SyncControlState.LOAD_ERROR: {
      return <SyncControlLoading error={syncControlState === SyncControlState.LOAD_ERROR} />;
    }

    default: {
      if (hideTriggerSync) {
        return (
          <div className={styles.container}>
            <span className={styles.textColor}>
              <SyncMessage
                datasourceState={datasourceState}
                dataSyncedMessage={dataSyncedMessage}
                errorMessage={errorMessage}
                syncingMessage={syncingMessage}
                syncTimestamp={syncTimestamp}
              />
            </span>
          </div>
        );
      }
      return (
        <div className={styles.container}>
          <span className={styles.textColor}>
            <SyncMessage
              datasourceState={datasourceState}
              dataSyncedMessage={dataSyncedMessage}
              errorMessage={errorMessage}
              syncingMessage={syncingMessage}
              syncTimestamp={syncTimestamp}
            />
          </span>

          {datasourceState !== SyncControlDatasourceState.NOT_CONNECTED ? (
            <>
              {showSpinner ? (
                <Icon type="sync" className={clsx(styles.syncIcon, styles.svgSpin)} />
              ) : needsReconnect ? (
                <SyncControlReconnectCta onClick={onReconnect} showLabel={showSyncNowLabel} />
              ) : (
                <SyncControlCta onClick={onSyncNow} showLabel={showSyncNowLabel} message={syncNowMessage} />
              )}
            </>
          ) : (
            <SyncControlReconnectCta onClick={onReconnect} showLabel={showSyncNowLabel} />
          )}
        </div>
      );
    }
  }
};
